import { Divider, Flex, Row, Spin } from "antd";
import { ClaimKanbanLane } from "./components/ClaimKanbanLane";
import { useQuery } from "@tanstack/react-query";
import { ClaimKanbanFilters } from "./components/ClaimKanbanFilters";
import { fetchClaimsGroupedByStatus } from "../../../lib/api/resources/claims";

export type LaneGroup = "intake" | "calculatie" | "afgerond";

export interface Lane {
  key: string;
  label: string;
  group: LaneGroup;
}

/** Color accent per lane group */
export const groupColors: Record<LaneGroup, string> = {
  intake: "#faad14",
  calculatie: "#1677ff",
  afgerond: "#52c41a",
};

/* TODO: Retrieve this based on workflow transitions */
export const lanes: Lane[] = [
  { key: "concept", label: "Nieuw", group: "intake" },
  { key: "claim_verstuurd", label: "Wacht op calculatie", group: "calculatie" },
  {
    key: "calculatie_ontvangen",
    label: "Calculatie beoordelen",
    group: "calculatie",
  },
  {
    key: "calculatie_expertise_aangevraagd",
    label: "Wacht op expertise",
    group: "calculatie",
  },
  {
    key: "calculatie_expertise_ontvangen",
    label: "Expertise beoordelen",
    group: "calculatie",
  },
  {
    key: "calculatie_goedgekeurd",
    label: "Calculatie beoordeeld",
    group: "afgerond",
  },
];

export default function ClaimKanbanOverview() {
  // const [query, setQuery] = useState("");

  const claimsQuery = useQuery({
    queryKey: ["claims", "by-status"],
    queryFn: fetchClaimsGroupedByStatus,
  });

  const claims = claimsQuery.data || {};

  // Client-side text filtering per lane (TODO: move server-side)
  // const filterFn = (arr: Claim[] = []) => {
  //   const q = query.toLowerCase();
  //   if (!q) return arr;
  //   return arr.filter(
  //     (dossier) =>
  //       dossier.vehicle.licensePlate.identifier.toLowerCase().includes(q) ||
  //       dossier.driver.person.fullName.toLowerCase().includes(q),
  //   );
  // };

  return (
    <div style={{ padding: 16 }}>
      <Flex vertical gap={16}>
        <ClaimKanbanFilters />
        <Divider style={{ margin: 0 }} />

        {claimsQuery.isLoading ? (
          <Spin />
        ) : (
          <Row className="overflow-x-scroll flex-nowrap" gutter={[16, 16]}>
            {lanes.map((lane) => {
              let laneClaims = claims[lane.key] || [];

              // For the "calculatie beoordeeld" lane, include both approved and rejected calculations
              if (lane.key === "calculatie_goedgekeurd") {
                const approvedClaims = claims["calculatie_goedgekeurd"] || [];
                const rejectedClaims = claims["calculatie_afgekeurd"] || [];
                laneClaims = [...approvedClaims, ...rejectedClaims];
              }

              return (
                <ClaimKanbanLane
                  key={lane.key}
                  title={lane.label}
                  claims={laneClaims}
                  groupColor={groupColors[lane.group]}
                />
              );
            })}
          </Row>
        )}
      </Flex>
    </div>
  );
}
